var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#21BE79"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5918 27.0919L31.5918 51.0919C31.3828 51.3017 31.1344 51.4681 30.8609 51.5816C30.5874 51.6952 30.2942 51.7537 29.998 51.7537C29.7019 51.7537 29.4087 51.6952 29.1352 51.5816C28.8617 51.4681 28.6133 51.3017 28.4043 51.0919L17.9043 40.5919C17.695 40.3826 17.529 40.1341 17.4157 39.8607C17.3024 39.5872 17.2441 39.2941 17.2441 38.9981C17.2441 38.7022 17.3024 38.4091 17.4157 38.1356C17.529 37.8622 17.695 37.6137 17.9043 37.4044C18.1136 37.1951 18.3621 37.0291 18.6355 36.9158C18.909 36.8025 19.2021 36.7442 19.498 36.7442C19.794 36.7442 20.0871 36.8025 20.3606 36.9158C20.634 37.0291 20.8825 37.1951 21.0918 37.4044L29.9999 46.3125L52.408 23.9081C52.8307 23.4854 53.404 23.248 54.0018 23.248C54.5996 23.248 55.1729 23.4854 55.5955 23.9081C56.0182 24.3308 56.2557 24.9041 56.2557 25.5019C56.2557 26.0997 56.0182 26.673 55.5955 27.0956L55.5918 27.0919Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.19b0c9a7ccbc1edefe2fdab870ff383d.svg";
export { ForwardRef as ReactComponent };